<template>
    <div class="m-3">
        <p>I started stacking during the summer of 2006. A year later, I participated in my first tournament, breaking all three individual Connecticut state records. I have held those overall male state records since that tournament. After the creation of the 16 year old division from the 15-18 year old division in 2008, I briefly held the USA national 3-3-3 and 3-6-3 divisional records.</p>
        <p>At the end of 2009, my relay team at the Connecticut state championship broke the 18 and under world record for the timed 3-6-3 with a time of 13.00. At the time it was set it was the second fastest time in history. At the beginning of 2010, I was invited to join USA Sport Stacking.</p>
        <p>At the end of 2010 I broke 2 of the 3 individual world records for my age division. I helped USA win the 2011 Can-Am Cup at the end of January. In February, I won overall champion at the 2011 WSSA Jacobsville Sport Stacking Championships with a combined time of 11.47. I also broke all three individual age division world records. At the 2011 World Sport Stacking Championship, I became the age division world champion for the 3-6-3 and Cycle.</p>
        <p>I completed in the Collegiate division between 2011 and 2017. During that time, I held the Collegiate division 3-6-3 and Cycle world record for a few months, but those records have since been broken. Between 2011 and 2012, I broke or tied at least one age division world record in 10 consecutive tournaments. In June 2013 I, along with Andrew Purugganan, Kailey Diedrick, and Rachael Nedrow, set the Guinness World Record for the Timed Cycle Relay. At the 2015 World Championship in Montreal, I, along with my team Full Metal STACKit, won the 19+ Head-to-Head Cycle Relay world championship.</p>
        <p> In 2017, I moved up to the Masters 1 division. I quickly set the individual world records, but they have since been broken. In October 2017 I competed at the 50th sanctioned competition of my career. At the 2018 World Sport Stacking Championship, I won 6 of the 7 events I competed in, as well as setting the relay world record with members of Team Germany. The following year, I won the cycle for the Masters 1 division, bringing my career totals to 10 world championships and 28 world records.</p>

        <h3>Times and Rankings</h3>
        <p>For my official times and rankings, please visit <a href="http://www.thewssa.com/sport-stackers/jonathan-scannell/1213/">my WSSA profile</a>.</p>


        <b-overlay :show="loading">
            <h3>In the News</h3>
            <p v-for="article in sortedArticles" :key="article.id">
                <NewspaperCitation
                    :url="article.url"
                    :title="article.title"
                    :publication="article.publication"
                    :author="article.author"
                    :date="article.date" />
            </p>
        </b-overlay>
    </div>
</template>

<script>
import NewspaperCitation from './NewspaperCitation.vue';

export default {
    data() {
        return {
            articles: [],
            loading: true
        }
    },
    computed: {
        sortedArticles() {
            return this.articles.slice().sort((a, b) => a["id"] < b["id"]);
        }
    },
    components: {
        NewspaperCitation
    },
    created() {
        fetch("https://jonscannell-com.firebaseio.com/articles.json")
            .then(response => response.json())
            .then(articles => {
                this.articles = articles;
                this.loading = false;
            });
    }
}
</script>
